module.exports = __webpack_public_path__ + "img/pdf-to-dms.8164f5bd.png";